import { Link } from "react-router-dom";
import { useRecordContext } from "react-admin";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Button from "@mui/material/Button";

import resources from "../../constants/resources";
import { SHOW_LABEL } from "../../constants/titleConstants";

const ContentItemShowButton = ({ contentTypeQueryParam, contentId }) => {
  const record = useRecordContext();
  return (
    <Button
      variant="text"
      component={Link}
      /* eslint-disable-next-line max-len */
      to={`/${resources.CONTENT_ITEMS.url}/${record.id}/show?ct=${contentTypeQueryParam}&cid=${contentId}`}
      title={SHOW_LABEL}
      startIcon={<VisibilityIcon />}
    >
      {SHOW_LABEL}
    </Button>
  );
};

export default ContentItemShowButton;
